var _path, _path2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 14.6875V13.5208C13.6667 12.902 13.4209 12.3085 12.9833 11.8709C12.5457 11.4333 11.9522 11.1875 11.3334 11.1875H6.66671C6.04787 11.1875 5.45438 11.4333 5.01679 11.8709C4.57921 12.3085 4.33337 12.902 4.33337 13.5208V14.6875M11.3334 6.52083C11.3334 7.8095 10.2887 8.85417 9.00004 8.85417C7.71138 8.85417 6.66671 7.8095 6.66671 6.52083C6.66671 5.23217 7.71138 4.1875 9.00004 4.1875C10.2887 4.1875 11.3334 5.23217 11.3334 6.52083Z",
    stroke: "currentColor",
    strokeWidth: 1.27273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7337 1.5625L2.875 2.99432L9.2663 4.1875L15.125 2.99432L8.7337 1.5625Z",
    stroke: "currentColor",
    strokeWidth: 0.875
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.8125,
    y1: 3.3125,
    x2: 13.8125,
    y2: 5.9375,
    stroke: "currentColor",
    strokeWidth: 0.875
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 5.9375,
    r: 0.875,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/Graduation.affab2780811db34b1512fc306b1da3c.svg";
export { ForwardRef as ReactComponent };